import { createFileRoute, redirect } from '@tanstack/react-router'
import { getAuth } from 'firebase/auth'
import { motion } from 'framer-motion'
// import { AgentCarousel } from '../components/common/AgentCarousel'
import { AgentCard } from '../components/common/AgentCard'
import ParticlesEffect from '../components/common/particles/ParticleEffect'
import '../index.css'
import { setFavicon } from '../utils/setFavicon'
import { setPageTitle } from '../utils/setPageTitle'
import { UserButton } from '../components/navbar/UserButton'

export const Route = createFileRoute('/')({
  component: Home,
  beforeLoad: async () => {
    const user = getAuth().currentUser
    if (!user) {
      throw redirect({ to: '/login' })
    }
  },
})

function Home() {
  const atlasLogo = '/assets/atlas-light-isotipo.png'
  // const cronosLogo = '/assets/cronos-light-isotipo.png'
  const irisLogo = '/assets/iris-light-isotipo.png'
  const talosLogo = '/assets/talos-light-isotipo.png'

  setFavicon('/assets/primario_isotipo.png')
  setPageTitle('Sofka Agents')
  return (
    <>
      <motion.div
        id="home-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative flex items-center flex-col sm:min-h-screen justify-center z-10 overflow-hidden py-12 px-4 font-inter"
      >
        {/* Decorative background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-shell opacity-10 rounded-full blur-3xl"
            animate={{
              scale: [1, 1.1, 1],
              opacity: [0.1, 0.3, 0.1],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />
          <motion.div
            className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary-shell opacity-10 rounded-full blur-3xl"
            animate={{
              scale: [1, 1.1, 1],
              opacity: [0.1, 0.25, 0.1],
            }}
            transition={{
              duration: 12,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />
        </div>

        <UserButton />
        <motion.div
          className="relative text-center mb-16 max-w-4xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h1 className="text-6xl md:text-7xl font-bold text-text-primary mb-6 leading-tight">
            Bienvenido a
            <br />
            <span className="bg-linear-to-r from-primary-shell to-secondary-shell bg-clip-text text-transparent ">
              Sofka Agents
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
            Accede a los mejores agentes para acelerar el desarrollo de tus proyectos y llevar tu productividad al
            siguiente nivel.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 2xl:grid-cols-3 sm:grid-cols-2 gap-6 w-full max-w-6xl pb-8 md:pb-0"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* <AgentCarousel
            agents={[
              {
                to: '/talos/$',
                logo: talosLogo,
                logoAlt: 'Talos Logo',
                title: 'Explorar Talos',
                description: 'Potencia tu flujo de trabajo con inteligencia autónoma',
                accentColor: 'talos',
              },
              {
                to: '/iris/$',
                logo: irisLogo,
                logoAlt: 'Iris Logo',
                title: 'Explorar Iris',
                description: 'Genera requerimientos y prototipos a partir de contexto de negocio.',
                accentColor: 'iris',
              },
              {
                to: '/atlas/$',
                logo: atlasLogo,
                logoAlt: 'Atlas Logo',
                title: 'Explorar Atlas',
                description: 'Arquitectura inteligente para tus proyectos',
                accentColor: 'atlas',
              },
              {
                to: '/cronos/$',
                logo: cronosLogo,
                logoAlt: 'Cronos Logo',
                title: 'Explorar Cronos',
                description: 'Estima tus proyectos con precisión milimétrica',
                accentColor: 'cronos',
              },
            ]}
          /> */}
          <AgentCard
            to="/iris/$"
            logo={irisLogo}
            logoAlt="Iris Logo"
            title="Explorar Iris"
            description="Genera requerimientos y prototipos a partir de contexto de negocio."
            accentColor="iris"
          />
          <AgentCard
            to="/atlas/$"
            logo={atlasLogo}
            logoAlt="Atlas Logo"
            title="Explorar Atlas"
            description="Arquitectura inteligente para tus proyectos"
            accentColor="atlas"
          />
          {/* <AgentCard
            to="/cronos/$"
            logo={cronosLogo}
            logoAlt="Cronos Logo"
            title="Explorar Cronos"
            // description="Estima tus proyectos con precisión milimétrica"
            description="En mantenimiento"
            accentColor="cronos"
            disabled
          /> */}
          <AgentCard
            to="/talos/$"
            logo={talosLogo}
            logoAlt="Talos Logo"
            title="Explorar Talos"
            description="Potencia tu flujo de trabajo con inteligencia autónoma"
            accentColor="talos"
          />
        </motion.div>

        {/* Footer */}
        <motion.footer
          className="absolute bottom-0 left-0 right-0 py-6 text-center z-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <p className="text-sm text-text-tertiary">
            © Sofka {new Date().getFullYear()} - Todos los derechos reservados.
          </p>
        </motion.footer>
      </motion.div>
      <ParticlesEffect />
      <div className="bg-background-primary fixed inset-0 w-screen md:h-screen h-full -z-10"></div>
    </>
  )
}
